var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "function-panel" }, [
    _c("label", { staticClass: "section-label" }, [_vm._v("函数")]),
    _c(
      "div",
      { staticClass: "function-categories" },
      _vm._l(_vm.categories, function (category) {
        return _c("div", { key: category.name, staticClass: "category-item" }, [
          _c(
            "div",
            {
              staticClass: "category-header",
              on: {
                click: function ($event) {
                  return _vm.toggleCategory(category.name)
                },
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-arrow-right",
                class: {
                  "rotate-90": _vm.expandedCategories.includes(category.name),
                },
              }),
              _vm._v(" " + _vm._s(category.name) + " "),
            ]
          ),
          _vm.expandedCategories.includes(category.name)
            ? _c(
                "div",
                { staticClass: "function-list" },
                _vm._l(category.functions, function (func) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.searchQuery || _vm.isFunctionMatchSearch(func),
                          expression:
                            "!searchQuery || isFunctionMatchSearch(func)",
                        },
                      ],
                      key: func.name,
                      staticClass: "function-item",
                      on: {
                        click: function ($event) {
                          return _vm.handleFunctionClick(func)
                        },
                        mouseenter: function ($event) {
                          return _vm.handleFunctionMouseEnter(func)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(func.name) + " ")]
                  )
                }),
                0
              )
            : _vm._e(),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }